<template>
  <list
    ref="list"
    :get-data-func="api.list"
    :page="true"
    :query-params="params"
    :show-query="showQuery"
    :show-checkbox="$permission.canDel()"
    row-key="ComplainId"
    unit="投诉处理"
  >
    <template slot="query">
      <el-form-item label="投诉类型">
        <el-select v-model="params.ComplainType" style="width: 180px" clearable>
          <el-option
            v-for="item in ComplainList "
            :key="item.DataId"
            :value="item.DataName"
            :label="item.DataName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="投诉对象">
        <el-input v-model="params.MemberName" style="width: 180px" clearable placeholder="请输入投诉对象" />
      </el-form-item>
      <el-form-item label="投诉日期">
        <range-picker
          ref="picker"
          :date="[params.DateStart, params.DateEnd]"
          @change="x => { params.DateStart = x.Start; params.DateEnd = x.End }"
        ></range-picker>
      </el-form-item>
      <el-form-item label="处理状态">
        <el-select v-model="params.ResultStatus"  style="width: 180px" clearable>
          <el-option :value="0" label="未受理"></el-option>
          <el-option :value="1" label="已受理"></el-option>
          <el-option :value="2" label="已处理"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="params.Status" style="width: 180px" clearable>
          <el-option :value="0" label="草稿"></el-option>
          <el-option :value="1" label="待审批"></el-option>
          <el-option :value="2" label="退回"></el-option>
          <el-option :value="3" label="已审批"></el-option>
        </el-select>
      </el-form-item>
    </template>
    <template slot="table">
      <el-table-column align="center" label="投诉类型" min-width="70" prop="ComplainType">
        <template slot-scope="{row}">{{ row.ComplainType }}</template>
      </el-table-column>
      <el-table-column align="center" label="投诉对象" min-width="180" prop="MemberName" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="投诉日期" min-width="100" prop="ComplainDate">
        <template slot-scope="{row}">{{ $commonJs.toDateString(row.ComplainDate) }}</template>
      </el-table-column>
      <el-table-column align="center" label="投诉内容" min-width="400" prop="Content"></el-table-column>
      <el-table-column align="center" label="处理状态" min-width="100" prop="Status">
        <template slot-scope="{row}">
          <el-tag type="danger" v-if="row.ResultStatus == 0">未受理</el-tag>
          <el-tag  v-if="row.ResultStatus == 1">已受理</el-tag>
          <el-tag type="success" v-if="row.ResultStatus == 2">已处理</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="审批状态" min-width="60" prop="Status">
        <template slot-scope="{row}">
          <el-tag type="info" v-if="row.Status==0 && row.ResultStatus == 2 ">草稿</el-tag>
          <el-tag type="warning" v-if="row.Status==1 && row.ResultStatus == 2 ">待审批</el-tag>
          <el-tag type="danger" v-if="row.Status==2 && row.ResultStatus == 2 ">退回</el-tag>
          <el-tag type="success" v-if="row.Status==3 && row.ResultStatus == 2 ">已审批</el-tag>

        </template>
      </el-table-column>
      <slot name="column"></slot>
    </template>
  </list>
</template>

<script>
import rangePicker from "@/components/common/rangePicker";
import list from "@/components/common/list";
import listMixin from "@/mixins/list";

export default {
  mixins: [listMixin],
  components: {
    list,
    rangePicker
  },
  data() {
    return {
      api: require("@/api/consult/complaint").default,
      basicApi: require("@/api/basic/data").default,
      params: {
        ComplainType: "",
        MemberName: "",
        DateStart: "",
        DateEnd: "",
        ResultStatus: null,
        Status: null
      },
      ComplainList: [],
    };
  },
  beforeMount() {
    this.basicApi.list({ ClassName: '投诉类型', Status: 1 }).then(res => {
      this.ComplainList = res.Data;
      //("投诉类型");
      //(this.ComplainList);
    })
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>

<style>
</style>